/* MBG Choose Cards
   Turns the card track into a slider from tablet up, but only while the cards
   overflow the container. The arrows stay hidden whenever everything fits. */
(function () {
    'use strict';

    var ROOT_SELECTOR = '[data-mbg-choose-cards-slider]';
    var ACTIVE_CLASS = 'mbg-choose-cards__slider--active';
    var READY_ATTR = 'data-mbg-cc-ready';
    var TOLERANCE = 2;

    function MbgChooseCardsSlider(root) {
        this.root = root;
        this.track = root.querySelector('[data-mbg-cc-track]');
        this.prev = root.querySelector('[data-mbg-cc-prev]');
        this.next = root.querySelector('[data-mbg-cc-next]');

        if (!this.track || !this.prev || !this.next) {
            return;
        }

        this.onPrev = this.scrollBySlide.bind(this, -1);
        this.onNext = this.scrollBySlide.bind(this, 1);
        this.sync = this.sync.bind(this);

        this.prev.addEventListener('click', this.onPrev);
        this.next.addEventListener('click', this.onNext);

        this.sync();
        this.observe();
    }

    MbgChooseCardsSlider.prototype.observe = function () {
        if (window.ResizeObserver) {
            this.observer = new ResizeObserver(this.sync);
            this.observer.observe(this.track);
        } else {
            window.addEventListener('resize', this.sync);
        }
    };

    MbgChooseCardsSlider.prototype.overflows = function () {
        return this.track.scrollWidth - this.track.clientWidth > TOLERANCE;
    };

    MbgChooseCardsSlider.prototype.sync = function () {
        var active = this.overflows();

        if (active) {
            this.root.classList.add(ACTIVE_CLASS);
        } else {
            this.root.classList.remove(ACTIVE_CLASS);
            this.track.scrollLeft = 0;
        }

        this.prev.setAttribute('aria-hidden', active ? 'false' : 'true');
        this.next.setAttribute('aria-hidden', active ? 'false' : 'true');
        this.prev.tabIndex = active ? 0 : -1;
        this.next.tabIndex = active ? 0 : -1;
    };

    /* One card + one gap per click; wraps around at both ends. */
    MbgChooseCardsSlider.prototype.step = function () {
        var card = this.track.firstElementChild;

        if (!card) {
            return this.track.clientWidth;
        }

        var gap = parseFloat(window.getComputedStyle(this.track).columnGap);

        return card.getBoundingClientRect().width + (isNaN(gap) ? 0 : gap);
    };

    MbgChooseCardsSlider.prototype.scrollBySlide = function (direction) {
        var max = this.track.scrollWidth - this.track.clientWidth;

        if (max <= TOLERANCE) {
            return;
        }

        var target;

        if (direction > 0 && this.track.scrollLeft >= max - TOLERANCE) {
            target = 0;
        } else if (direction < 0 && this.track.scrollLeft <= TOLERANCE) {
            target = max;
        } else {
            target = this.track.scrollLeft + direction * this.step();
        }

        this.track.scrollTo({
            left: Math.max(0, Math.min(max, target)),
            behavior: 'auto'
        });
    };

    function init(context) {
        var scope = context && context.querySelectorAll ? context : document;
        var roots = scope.querySelectorAll(ROOT_SELECTOR);

        for (var i = 0; i < roots.length; i++) {
            if (roots[i].getAttribute(READY_ATTR)) {
                continue;
            }

            roots[i].setAttribute(READY_ATTR, 'true');
            new MbgChooseCardsSlider(roots[i]);
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            init(document);
        });
    } else {
        init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
        init(event.target || document);
    });
})();
